var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"signUp"}},[_c('appHeader'),_c('router-view',{staticClass:"content-body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }